import React from "react";
import Image from "../../../components/AppImage";
import Button from "../../../components/ui/Button2"; // تأكد من استيراد زر Button الصحيح
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import Skeleton from "react-loading-skeleton";
import { setFilterData, setProductNull } from "redux/slices/general";
import { getAllProductsService } from "redux/services/general_service";
import { useNavigate } from "react-router-dom";

const CategoryGrid = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { categoriesList } = useSelector((state) => state.general);
  const { t } = useTranslation();

  const handleCategoryClick = (id) => {
    const filterData = { categories: [id] }; // أو حسب formatParams في FilterPanel
    dispatch(setFilterData(filterData));
    dispatch(setProductNull()); // لإعادة تعيين المنتجات
    dispatch(getAllProductsService({ page: 1, categories: [id] })); // استدعاء الفلتر فورًا

    // انتقل إلى الصفحة ا (window.location.href = "/product-listing?featured=true")لتالية
    navigate(`/product-listing?categories=${id}`);
  };

  return (
    <section className="w-full py-[30px] sm:py-[45px] lg:py-[60px] px-[20px] sm:px-[20px] lg:px-[56px]">
      <div className="w-full max-w-[1182px] mx-auto">
        <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center mb-[14px] sm:mb-[21px] lg:mb-[28px]">
          <div className="mb-4 sm:mb-0 max-w-md">
            <h2 className="text-[18px] sm:text-[21px] lg:text-[24px] font-svn-gilroy font-bold leading-[20px] sm:leading-[23px] lg:leading-[26px] text-global-text4 capitalize">
              {t("shopByCategory")}
            </h2>
          </div>

          {/* زر العرض بجانب العنوان - مخفي في الشاشات الصغيرة */}
          <Button
            variant="outline"
            onClick={() => (window.location.href = "/product-listing")}
            className="border border-global-text4 text-global-text4 rounded-[22px] px-[24px] sm:px-[36px] lg:px-[48px] py-[6px] sm:py-[9px] lg:py-[12px] flex items-center gap-[4px] sm:gap-[6px] lg:gap-[8px] text-[11px] sm:text-[12px] lg:text-[14px] hidden sm:flex"
          >
            {t("view_more")}
          </Button>
        </div>

        {/* شبكة الكاتيجوري */}
        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-[10px] sm:gap-[15px] lg:gap-[20px]">
          {categoriesList?.length === 0 ? (
            <>
              {Array.from({ length: 6 }).map((_, index) => (
                <div
                  key={index}
                  className="bg-global-6 rounded-[12px] p-[6px] shadow-[0px_4px_28px_#00000014]"
                >
                  <Skeleton height={160} className="rounded-[10px]" />
                  <div className="p-[6px]">
                    <Skeleton height={20} />
                  </div>
                </div>
              ))}
            </>
          ) : (
            categoriesList?.slice(0, 6)?.map((category, index) => (
              <div
                key={index}
                onClick={() => handleCategoryClick(category?.id)}
                className="cursor-pointer bg-global-6 rounded-[12px] p-[6px] shadow-[0px_4px_28px_#00000014] hover:shadow-[0px_6px_32px_#00000022] transition-shadow duration-300"
              >
                <div className="bg-global-6 rounded-[10px] overflow-hidden mb-[6px]">
                  <Image
                    src={category?.image}
                    alt={category?.name}
                    className="w-full h-[160px] sm:h-[198px] lg:h-[264px] object-fill rounded-[10px] group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <div className="p-[6px]">
                  <h3 className="text-[14px] sm:text-[16px] lg:text-[18px] font-svn-gilroy font-bold leading-[20px] sm:leading-[22px] lg:leading-[24px] text-global-text2 text-center">
                    {category?.name}
                  </h3>
                </div>
              </div>
            ))
          )}
        </div>

        {/* زر العرض تحت الكاتيجوري في الشاشات الصغيرة فقط */}
        <div className="mt-6 block sm:hidden">
          <Button
            variant="outline"
            onClick={() => (window.location.href = "/product-listing")}
            className="w-full border border-global-text4 text-global-text4 hover:bg-global-text3 rounded-[22px] py-[12px] flex items-center justify-center gap-[8px] text-[14px]"
          >
            {t("view_more")}
          </Button>
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
